<section class="" id="add-property-financials-step">
	<header class="row page-header">
        <p>Enter the details of the property you want to add.</p>
	</header>
	<main>
        <form [formGroup]="formGroup">

			<div class="form-section">
				<div class="form-section-container">
					<h2 class="section-header">Fiscal Year</h2>

					<div class="row">
						<div class="col-md-6 col-sm-12">
							<label for="fiscalYearStartMonth">What is the date your fiscal year begins?</label>
						</div>
						<div class="col-md-5 col-sm-12">
							<select class="sp-select form-control" formControlName="fiscalYearStartMonth" placeholder="Start Date" name="fiscalYearStartMonth"
								#fiscalYearStartMonth id="fiscalYearStartMonth">
								<option *ngFor="let startDate of fiscalYearStartDates; let i = index" value="{{i+1}}">{{ startDate }}</option>
                            </select>
                            <sp-field-error [controlName]="'Fiscal year begins'" [control]="formGroup.controls['fiscalYearStartMonth']"></sp-field-error>
						</div>
					</div>

					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label for="startingFiscalYear">Starting Fiscal Year</label>
						</div>
						<div class="col-md-5 col-sm-12">
							<select class="sp-select form-control" formControlName="startingFiscalYear" placeholder="Start Date"
								name="startingFiscalYear" #startingFiscalYear id="startingFiscalYear">
								<option *ngFor="let fiscalYear of startingFiscalYearsOptions; let i = index"
									value="{{startingFiscalYearsOptions[i]}}">{{ fiscalYear }}</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<div class="form-section">
				<div class="form-section-container">
					<h2 class="section-header">Annual {{ 'Assessment' | terminology | async }} Fees</h2>

					<div class="row">
						<div class="col-md-6 col-sm-12">
							<label>How much do you collect annually in annual {{ 'assessment' | terminology | async }} fees? &nbsp;<span class="red">*</span></label>
						</div>
						<div class="col-md-5 col-sm-12">
							<div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-usd" aria-hidden="true"></i></span>
                                </div>
								<input type="text" class="form-control" formControlName="averageHoaAnnualFee"
                                       name="averageHoaAnnualFee" [placeholder]="'Annual ' + (('Assessment' | terminology | async) || 'Assessment') + ' Fees'" maxlength="13" spAutoNumeric />
							</div>
                            <sp-field-error [controlName]="'Annual Assessment Fees'" [control]="formGroup.controls['averageHoaAnnualFee']"></sp-field-error>
						</div>
					</div>

					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
						<label>How often do you collect {{ 'assessment' | terminology | async }} fees?&nbsp;<span class="red">*</span></label>
						</div>
						<div class="col-md-5">
							<div class="input-group">
								<select class="sp-select form-control" formControlName="feeCollectionFrequencyId" name="feeCollectionFrequencyId"
										#feeCollectionFrequencyId>
									<option *ngFor="let frequency of collectionFrequencies" value="{{frequency.id}}">{{ frequency.name }}</option>
								</select>
							</div>
                            <sp-field-error [controlName]="'Assessment Collection Frequency'" [control]="formGroup.controls['feeCollectionFrequencyId']"></sp-field-error>

                        </div>
					</div>

					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label for="annualReserveContribution">Of those total annual {{ 'assessment' | terminology | async }} fees collected, what amount is allocated for funding your reserves? &nbsp;<span class="red">*</span></label>
						</div>
						<div class="col-md-5 col-sm-12">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-usd" aria-hidden="true"></i></span>
                                </div>
                                <input type="text" class="form-control" placeholder="Annual Reserve Contributions" formControlName="annualReserveContribution"
                                       #annualReserveContribution id="annualReserveContribution" name="annualReserveContribution" spAutoNumeric maxlength="15" />
                            </div>
                            <sp-field-error [controlName]="'Annual Reserve Contributions'" [control]="formGroup.controls['annualReserveContribution']"></sp-field-error>
						</div>
					</div>
				</div>
			</div>

			<div class="form-section">
				<div class="form-section-container">
					<h2 class="section-header">Reserve Account</h2>

					<div class="row">
						<div class="col-md-6 col-sm-12">
							<label>How much cash will be in your reserve account? &nbsp;<span class="red">*</span></label>
						</div>
						<div class="col-md-5 col-sm-12">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-usd" aria-hidden="true"></i></span>
                                </div>
                                <input type="text" class="form-control" placeholder="Reserve Account Cash" name="yearEndReserveBalance" formControlName="yearEndReserveBalance"
                                       #yearEndReserveBalance spAutoNumeric maxlength="15" />
                            </div>
                            <sp-field-error [controlName]="'Reserve Account Cash'" [control]="formGroup.controls['yearEndReserveBalance']"></sp-field-error>
						</div>
					</div>

					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label for="reserveMonthStart">As of the selected date</label>
						</div>
						<div class="col-md-5 col-sm-12 ">
							<select class="sp-select form-control" id="reserveMonthStart" formControlName="reserveMonthStart" placeholder="Start Date"
								name="reserveMonthStart" #reserveMonthStart>
								<option *ngFor="let startDate of fiscalYearStartDates; let i = index" value="{{i+1}}">{{ startDate }}</option>
								</select>
						</div>
					</div>

				</div>
			</div>

            <div class="form-section">
                <div class="form-section-container">
                    <h2 class="section-header">UPCOMING EXPENSES</h2>
                    <div class="row">
                        <div class="col-md-6 clear-padding-right">
                            <label>
                                Do you have any scheduled repair or replacement projects that
                                will be funded from your reserves between now and the end of the fiscal year?
                            </label>
                        </div>
                        <div class="col-md-5">
                            <label class="btn-radio-container"><input type="radio" [value]="false" #hasExpensesNo formControlName="hasExpensesYesNo"><span></span> No</label>
                            <label class="btn-radio-container"><input type="radio" [value]="true" #hasExpensesYes formControlName="hasExpensesYesNo"><span></span> Yes</label>
                        </div>
                    </div>

                    <ng-container *ngIf="hasExpensesYes.checked">
                        <div class="row top-buffer-20">
                            <div class="col-md-6 clear-padding-right">
                                <label for="upcomingExpenses">
                                    What amount have you budgeted to spend from reserves on the
                                    scheduled repair or replacement projects between now and the
                                    end of the fiscal year? &nbsp;<span class="red">*</span>
                                </label>
                            </div>
                            <div class="col-md-5">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fa fa-usd" aria-hidden="true"></i></span>
                                    </div>
                                    <input type="text" spAutoNumeric class="form-control" formControlName="upcomingExpenses"
                                           name="upcomingExpenses" #upcomingExpenses id="upcomingExpenses" placeholder="Upcoming Expenses"
                                           maxlength="15" />
                                </div>
                                <sp-field-error [controlName]="'Upcoming Expenses'" [control]="formGroup.controls['upcomingExpenses']"></sp-field-error>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="form-section">
				<div class="form-section-container">
					<h2 class="section-header">FINANCIAL Assumptions</h2>

					<div class="row">
						<div class="col-md-6 col-sm-12">
							<label>Inflation Rate</label>&nbsp;<span class="red">*</span>
						</div>
						<div class="col-md-5 col-sm-12">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                                </div>
                                <input type="text" class="form-control" name="inflationRate" maxlength="5" #inflationRate formControlName="inflationRate"
                                       placeholder="Inflation Rate" spAutoNumeric />
                            </div>
                            <sp-field-error [controlName]="'Inflation Rate'" [control]="formGroup.controls['inflationRate']"></sp-field-error>
						</div>
					</div>

					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label>Interest Rate</label>&nbsp;<span class="red">*</span>
						</div>
						<div class="col-md-5 col-sm-12">
							<div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                                </div>
								<input type="text" class="form-control" name="interestRate" formControlName="interestRate"
									maxlength="5" #interestRate spAutoNumeric placeholder="Interest Rate" />
							</div>
                            <sp-field-error [controlName]="'Interest Rate'" [control]="formGroup.controls['interestRate']"></sp-field-error>
                        </div>
					</div>

					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label>Rate of Annual Reserve Contribution Increases</label>&nbsp;<span class="red">*</span>
						</div>
						<div class="col-md-5 col-sm-12 ">
							<div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                                </div>
								<input type="text" class="form-control" name="reserveContributionIncreaseRate" #reserveIncreaseRate formControlName="reserveContributionIncreaseRate"
									maxlength="5" placeholder="Increase Rate" spAutoNumeric />
							</div>
                            <sp-field-error [controlName]="'Rate of Annual Reserve Contribution Increases'" [control]="formGroup.controls['reserveContributionIncreaseRate']"></sp-field-error>
                        </div>
					</div>

				</div>
			</div>

			<div class="form-section">
				<div class="form-section-container">
					<h2 class="section-header">{{ 'Reserve Study' | terminology | async }}</h2>
			
					<div class="row">
						<div class="col-md-6 col-sm-12">
							<label>{{ 'Reserve Study' | terminology | async }} Date</label>
						</div>
			
						<div class="col-md-5 col-sm-12 ">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="fa fa-calendar" aria-hidden="true"></i></span>
								</div>
								<input type="text" type="date" class="form-control" formControlName="reserveStudyDate" />
							</div>
						</div>
					</div>
			
					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label>Type</label>
						</div>
			
						<div class="col-md-5 col-sm-12 ">
							<select class="sp-select form-control" formControlName="reserveStudyTypeId">
								<option value="">Select type of {{ 'reserve study' | terminology | async }}</option>
								<option value="1">Level 1: Full {{ 'Reserve Study' | terminology | async }}</option>
								<option value="2">Level 2: {{ 'Reserve Study' | terminology | async }} Update</option>
								<option value="3">Level 3: Financial Update</option>
								<option value="4">Level 4: Pre-Construction {{ 'Reserve Study' | terminology | async }}</option>
							</select>
						</div>
					</div>
			
					<div class="row top-buffer-20">
						<div class="col-md-6 col-sm-12">
							<label>Provider</label>
						</div>
			
						<div class="col-md-5 col-sm-12 ">
							<input type="text" placeholder="Provider's Name" class="form-control" name="providerName"
								formControlName="reserveStudyProviderName" />
						</div>
					</div>
				</div>
			</div>
		</form>
	</main>

        <!--
    <div class="alert alert-danger" role="alert" *ngIf="feedbackMessages.length !=0">
      <div *ngFor="let msg of feedbackMessages">
        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
        <span class="visually-hidden">Error:</span> {{ msg.details }}
      </div>
    </div>
    -->
</section>
